/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import FeedPost from './FeedPost';
import Text from '../../../../shared/_TBComponents/Text';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60%;
`;

const PinnedFeedTop = styled('div')`
  scroll-margin-top: 320px;
`;

const PinnedFeedBoxContent = ({ pinnedFeedTopRef }) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const pinnedFeed = useSelector((state) => state.feed.data.pinnedFeed);

  const feedMapper = (feedArray) => [
    <Text
      key='pinned-posts-header'
      styledTextProps={{
        fontSize: 12,
        fontWeight: 900,
        letterSpacing: 1.3,
        marginBottom: '20px',
      }}
    >
      PINNED POSTS
    </Text>,
    ...feedArray.map((feedObject) => (
      <FeedPost
        key={feedObject.id}
        feedObject={feedObject}
        timeZone={currentUser.userSettings.timeZone}
      />
    )),
  ];

  return (
    <>
      <PinnedFeedTop ref={pinnedFeedTopRef} />
      <Container>
        {feedMapper(pinnedFeed)}
      </Container>
    </>
  );
};

PinnedFeedBoxContent.propTypes = {
  pinnedFeedTopRef: PropTypes.instanceOf(Object).isRequired,
};

export default PinnedFeedBoxContent;
